<template>
  <div class="isolate-page">
    <nav>
      <div class="logo">{{ t.heroSubtitle }}</div>
      <div class="nav-group">
        <div class="nav-links">
          <a href="/home">{{ t.navHome }}</a>
          <a href="#about">{{ t.navAbout }}</a>
          <a href="#products">{{ t.navProducts }}</a>
          <a href="#advantages">{{ t.navAdvantages }}</a>
          <a href="#partner">{{ t.navPartner }}</a>
        </div>
        <select class="lang" v-model="lang" @change="changeLang">
          <option value="zh">中文</option>
          <option value="en">English</option>
          <option value="ja">日本語</option>
          <option value="ko">한국어</option>
          <option value="es">Español</option>
          <option value="tr">Türkçe</option>
          <option value="ru">Русский</option>
          <option value="fr">Français</option>
          <option value="pt">Português</option>
        </select>
      </div>
    </nav>

    <section id="home" class="hero">
      <div class="hero-inner">
        <div class="hero-left">
          <h1>{{ t.heroTitle }}<br><span class="highlight">{{ t.heroSubtitle }}</span></h1>
          <p>{{ t.heroDesc1 }}</p>
          <p>{{ t.heroDesc2 }}</p>
          <a href="#partner" class="btn">{{ t.heroBtn }}</a>
        </div>
        <div class="hero-right">
          <img src="https://img.zh-eng.com/elevator/zh-eng.jpg" alt="Hero">
        </div>
      </div>
    </section>

    <section id="about">
      <h2>{{ t.aboutTitle }}</h2>
      <div class="about-row">
        <div class="about-left">
          <img src="https://img.zh-eng.com/elevator/about.png" alt="About">
        </div>
        <div class="about-right">
          <p>{{ t.aboutDesc }}</p>
          <p>{{ t.aboutDesc2 }}</p>
          <p>{{ t.aboutDesc3 }}</p>
        </div>
      </div>
      <div class="grid">
        <div class="card"><div class="data">1000+</div><h3>{{ t.supplier }}</h3></div>
        <div class="card"><div class="data">100+</div><h3>{{ t.country }}</h3></div>
        <div class="card"><div class="data">300M+</div><h3>{{ t.sales }}</h3></div>
        <div class="card"><div class="data">4000+</div><h3>{{ t.client }}</h3></div>
      </div>
    </section>

    <section id="products">
      <h2>{{ t.productTitle }}</h2>
      <p>{{ t.productDesc }}</p>
      <div class="grid">
        <div class="card card-img">
          <img src="https://img.zh-eng.com/elevator/elevator.png" alt="Elevator">
          <h3>{{ t.p1 }}</h3>
          <p>{{ t.p1d }}</p>
        </div>
        <div class="card card-img">
          <img src="https://img.zh-eng.com/elevator/engineer.jpeg" alt="Engineering Products">
          <h3>{{ t.p2 }}</h3>
          <p>{{ t.p2d }}</p>
        </div>
        <div class="card card-img">
          <img src="https://img.zh-eng.com/elevator/house.png" alt="Prefabricated Houses">
          <h3>{{ t.p3 }}</h3>
          <p>{{ t.p3d }}</p>
        </div>
      </div>
    </section>

    <section id="advantages">
      <h2>{{ t.advTitle }}</h2>
      <div class="grid">
        <div class="card card-icon">🏭<h3>{{ t.a1 }}</h3><p>{{ t.a1d }}</p></div>
        <div class="card card-icon">✅<h3>{{ t.a2 }}</h3><p>{{ t.a2d }}</p></div>
        <div class="card card-icon">🛒<h3>{{ t.a3 }}</h3><p>{{ t.a3d }}</p></div>
        <div class="card card-icon">🚚<h3>{{ t.a4 }}</h3><p>{{ t.a4d }}</p></div>
      </div>
    </section>

    <section id="partner">
      <h2>{{ t.partnerTitle }}</h2>
      <p>{{ t.partnerDesc }}</p>
      <div class="partner-row">
        <div class="partner-left">
          <h3>📦 {{ t.offer }}</h3>
          <p>✔ {{ t.o1 }}</p>
          <p>✔ {{ t.o2 }}</p>
          <p>✔ {{ t.o3 }}</p>
          <p>✔ {{ t.o4 }}</p>
          <br>
          <h3>🤝 {{ t.youdo }}</h3>
          <p>• {{ t.y1 }}</p>
          <p>• {{ t.y2 }}</p>
          <p>• {{ t.y3 }}</p>
        </div>
        <div class="partner-right">
          <img src="https://picsum.photos/id/1071/600/400" alt="Partner">
        </div>
      </div>
      <a class="btn">{{ t.contactBtn }}</a>
    </section>
  </div>
</template>

<script>
export default {
  name: 'IsolatePage',
  data() {
    return {
      lang: 'en',
      t: {},
      messages: {
        zh: {
          navHome:"首页",navAbout:"关于我们",navProducts:"产品",navAdvantages:"优势",navPartner:"合作",
          heroTitle:"全球战略合作招商",heroSubtitle:"中华工程网",heroDesc1:"电梯零部件、工程产品、装配式房屋一站式采购平台",heroDesc2:"工厂直供 | 品质保证 | 价格最低",heroBtn:"成为合作伙伴",
          aboutTitle:"关于我们",aboutDesc:"我们是中国领先的外贸平台，专注电梯配件、工程产品与装配式房屋。",aboutDesc2:"拥有10年+外贸经验，服务全球100多个国家。",aboutDesc3:"以诚信、品质、效率为核心，打造长期共赢的合作体系。",
          supplier:"认证供应商",country:"服务国家",sales:"年销售额",client:"成交客户",
          productTitle:"核心产品",productDesc:"全系列产品，品质稳定，价格优势",
          p1:"电梯零部件",p1d:"电梯全系列配件、电气件、机械件，原厂品质，稳定供货",
          p2:"工程产品",p2d:"建材、工程设备、安装工具，一站式工程配套服务",
          p3:"装配式房屋",p3d:"模块化房屋、集装箱房、移动建筑，安全耐用，快速搭建",
          advTitle:"核心优势",
          a1:"工厂直供价格",a1d:"无中间商，保证同等质量最低价，利润空间更大",
          a2:"严格品控",a2d:"出货前全检，第三方质检，确保稳定可靠零故障",
          a3:"一站式采购",a3d:"全品类统一平台，省时省力，降低综合成本",
          a4:"快速安全交付",a4d:"成熟供应链体系，全球准时发货，不耽误工期",
          partnerTitle:"诚招全球合作伙伴",partnerDesc:"寻找各国本地代理、工程商、经销商，共同拓展海外市场",
          offer:"我们提供",o1:"最优价格全产品支持",o2:"质量保证与完善售后",o3:"市场与技术培训支持",o4:"长期稳定合作与返点政策",
          youdo:"您需要",y1:"开发本地客户，推广产品",y2:"建立长期共赢合作",y3:"维护区域市场与品牌形象",
          contactBtn:"立即联系合作"
        },
        en: {
          navHome:"Home",navAbout:"About",navProducts:"Products",navAdvantages:"Advantages",navPartner:"Partner",
          heroTitle:"Global Strategic Partnership",heroSubtitle:"ZH-ENG",heroDesc1:"One-Stop Sourcing for Elevator Parts, Engineering Products & Prefabricated Houses",heroDesc2:"Direct from China | Top Quality | Best Price",heroBtn:"Become Our Partner",
          aboutTitle:"About Us",aboutDesc:"Leading foreign trade platform for elevator parts, engineering products & prefab houses.",aboutDesc2:"10+ years experience, serving 100+ countries worldwide.",aboutDesc3:"Focus on integrity, quality and win-win cooperation.",
          supplier:"Certified Suppliers",country:"Countries Served",sales:"Annual Sales",client:"Clients",
          productTitle:"Our Products",productDesc:"Stable quality & competitive price",
          p1:"Elevator Components",p1d:"Full series parts, electrical & mechanical parts, stable supply",
          p2:"Engineering Products",p2d:"Construction materials, equipment & tools, one-stop service",
          p3:"Prefabricated Houses",p3d:"Modular & container houses, safe & fast construction",
          advTitle:"Our Advantages",
          a1:"Direct Factory Price",a1d:"No middleman, best price guaranteed, maximize profit",
          a2:"Strict QC",a2d:"100% inspection before shipment, third-party testing",
          a3:"One-Stop Sourcing",a3d:"Save time & cost, full category support",
          a4:"Fast Delivery",a4d:"Stable supply chain, on-time worldwide delivery",
          partnerTitle:"Become Our Global Partner",partnerDesc:"Looking for local agents & distributors worldwide",
          offer:"We Offer",o1:"Best price & full product support",o2:"Quality & after-sales service",o3:"Marketing & technical support",o4:"Long-term cooperation & rebate",
          youdo:"What You Do",y1:"Develop local customers",y2:"Build win-win partnership",y3:"Maintain market & brand",
          contactBtn:"Contact Us Now"
        },
        ja: {
          navHome:"ホーム",navAbout:"私たちについて",navProducts:"製品",navAdvantages:"強み",navPartner:"パートナー",
          heroTitle:"グローバル戦略パートナー",heroSubtitle:"ZH-ENG",heroDesc1:"エレベーター部品、建設製品、プレハブ住宅のワンストップ調達",heroDesc2:"中国直送 | 高品質 | 最低価格",heroBtn:"パートナーになる",
          aboutTitle:"私たちについて",aboutDesc:"エレベーター部品、建設製品、プレハブ住宅を扱う海外貿易プラットフォームです。",aboutDesc2:"10年以上の経験、世界100カ国以上にサービスを提供。",aboutDesc3:"誠実さ、品質、Win-Winを重視しています。",
          supplier:"認定サプライヤー",country:"サービス提供国",sales:"年間売上",client:"顧客数",
          productTitle:"製品紹介",productDesc:"安定した品質と競争力のある価格",
          p1:"エレベーター部品",p1d:"各種部品、電機部品、安定供給",
          p2:"建設製品",p1d:"建設資材、機材、ワンストップサービス",
          p3:"プレハブ住宅",p1d:"モジュールハウス、コンテナハウス、安全・迅速",
          advTitle:"私たちの強み",
          a1:"工場直送価格",a1d:"仲介なし、最安値保証",
          a2:"厳格な品質管理",a2d:"出荷前全品検査、第三者検査",
          a3:"ワンストップ調達",a3d:"時間とコスト削減",
          a4:"迅速な配送",a4d:"世界中に定時配送",
          partnerTitle:"グローバルパートナー募集",partnerDesc:"世界各国のローカルパートナーを募集しています",
          offer:"提供内容",o1:"最安値での製品サポート",o2:"品質保証とアフターサービス",o3:"マーケティング支援",o4:"長期協力",
          youdo:"あなたの役割",y1:"現地顧客開発",y2:"Win-Winの協力関係構築",y3:"市場・ブランド維持",
          contactBtn:"今すぐ問い合わせ"
        },
        ko: {
          navHome:"홈",navAbout:"회사소개",navProducts:"제품",navAdvantages:"장점",navPartner:"파트너",
          heroTitle:"글로벌 전략적 제휴",heroSubtitle:"ZH-ENG",heroDesc1:"엘리베이터 부품, 건자재, 조립식 주택 원스톱 조달",heroDesc2:"중국 직송 | 고품질 | 최저가",heroBtn:"파트너 되기",
          aboutTitle:"회사소개",aboutDesc:"엘리베이터 부품, 건자재, 조립식 주택 전문 무역 플랫폼입니다.",aboutDesc2:"10년 이상 경력, 전 세계 100여 개국 서비스.",aboutDesc3:"신뢰, 품질, 상생을 중시합니다.",
          supplier:"인증 공급업체",country:"서비스 국가",sales:"연매출",client:"고객 수",
          productTitle:"주요 제품",productDesc:"안정적인 품질과 경쟁력 있는 가격",
          p1:"엘리베이터 부품",p1d:"완성 부품, 전기·기계 부품, 안정 공급",
          p2:"건축 자재",p2d:"건자재, 장비, 원스톱 서비스",
          p3:"조립식 주택",p3d:"모듈러 주택, 컨테이너 하우스, 안전·신속 시공",
          advTitle:"핵심 장점",
          a1:"공장 직접 가격",a1d:"중간상 없음, 최저가 보장",
          a2:"엄격한 품질 관리",a2d:"출하 전 전수 검사, 제3자 검수",
          a3:"원스톱 조달",a3d:"시간 및 비용 절감",
          a4:"신속 납품",a4d:"전 세계 정시 배송",
          partnerTitle:"글로벌 파트너 모집",partnerDesc:"전 세계 현지 파트너를 모집합니다",
          offer:"제공 내용",o1:"최저가 제품 지원",o2:"품질 보증 및 A/S",o3:"마케팅 지원",o4:"장기 협력",
          youdo:"여러분의 역할",y1:"현지 고객 개발",y2:"상생 협력 구축",y3:"시장·브랜드 유지",
          contactBtn:"지금 문의하기"
        },
        es: {
          navHome:"Inicio",navAbout:"Nosotros",navProducts:"Productos",navAdvantages:"Ventajas",navPartner:"Socios",
          heroTitle:"Asociación Estratégica Global",heroSubtitle:"ZH-ENG",heroDesc1:"Suministro integral para piezas de ascensor, productos de ingeniería y casas prefabricadas",heroDesc2:"Directo de China | Calidad | Mejor Precio",heroBtn:"Hazte Socio",
          aboutTitle:"Sobre Nosotros",aboutDesc:"Plataforma líder en comercio exterior especializada en piezas de ascensor y construcción.",aboutDesc2:"10+ años de experiencia, 100+ países.",aboutDesc3:"Integridad, calidad y colaboración ganadora.",
          supplier:"Proveedores Certificados",country:"Países Servidos",sales:"Ventas Anuales",client:"Clientes",
          productTitle:"Nuestros Productos",productDesc:"Calidad estable y precio competitivo",
          p1:"Componentes de Ascensor",p1d:"Piezas eléctricas y mecánicas, suministro estable",
          p2:"Productos de Ingeniería",p2d:"Materiales, equipos, servicio integral",
          p3:"Casas Prefabricadas",p3d:"Modulares y contenedores, seguras y rápidas",
          advTitle:"Nuestras Ventajas",
          a1:"Precio Fábrica",a1d:"Sin intermediarios, mejor precio garantizado",
          a2:"Control de Calidad",a2d:"100% inspección antes de envío",
          a3:"Suministro Integral",a3d:"Ahorra tiempo y coste",
          a4:"Entrega Rápida",a4d:"Entrega a tiempo mundial",
          partnerTitle:"Hazte Socio Global",partnerDesc:"Buscamos socios locales en todo el mundo",
          offer:"Ofrecemos",o1:"Mejor precio y soporte",o2:"Calidad y postventa",o3:"Soporte técnico",o4:"Colaboración larga duración",
          youdo:"Tu Función",y1:"Desarrollar clientes locales",y2:"Crear alianzas ganadoras",y3:"Mantener mercado y marca",
          contactBtn:"Contáctanos Ahora"
        },
        tr: {
          navHome:"Anasayfa",navAbout:"Hakkımızda",navProducts:"Ürünler",navAdvantages:"Avantajlar",navPartner:"Ortaklar",
          heroTitle:"Küresel Stratejik Ortaklık",heroSubtitle:"ZH-ENG",heroDesc1:"Asansör parçaları, inşaat ürünleri ve prefabrik evler için tek kaynaktan tedarik",heroDesc2:"Çin'den doğrudan | Üstün kalite | En iyi fiyat",heroBtn:"Ortak Ol",
          aboutTitle:"Hakkımızda",aboutDesc:"Asansör parçaları ve inşaat ürünleri uzmanlaşmış dış ticaret platformuyuz.",aboutDesc2:"10+ yıl deneyim, 100+ ülke hizmeti.",aboutDesc3:"Dürüstlük, kalite ve kazançlı işbirliği.",
          supplier:"Sertifikalı Tedarikçiler",country:"Hizmet Verilen Ülkeler",sales:"Yıllık Satış",client:"Müşteriler",
          productTitle:"Ürünlerimiz",productDesc:"Stabil kalite ve rekabetçi fiyat",
          p1:"Asansör Parçaları",p1d:"Elektrik ve mekanik parçalar, stabil tedarik",
          p2:"İnşaat Ürünleri",p2d:"Malzemeler, ekipmanlar, tek kaynaktan hizmet",
          p3:"Prefabrik Evler",p3d:"Modüler ve konteyner evler, güvenli ve hızlı",
          advTitle:"Avantajlarımız",
          a1:"Fabrika Fiyatı",a1d:"Aracı yok, en düşük fiyat garantili",
          a2:"Sıkı Kalite Kontrolü",a2d:"Gönderim öncesi %100 kontrol",
          a3:"Tek Kaynaktan Tedarik",a3d:"Zaman ve maliyet tasarrufu",
          a4:"Hızlı Teslimat",a4d:"Dünya çapında zamanında teslimat",
          partnerTitle:"Küresel Ortak Arıyoruz",partnerDesc:"Dünya genelinde yerel ortaklar arıyoruz",
          offer:"Sunduğumuz",o1:"En iyi fiyat ve ürün desteği",o2:"Kalite ve satış sonrası",o3:"Pazarlama desteği",o4:"Uzun süreli işbirliği",
          youdo:"Yapacaklarınız",y1:"Yerel müşteriler geliştirin",y2:"Kazançlı işbirliği kurun",y3:"Pazarı ve markayı koruyun",
          contactBtn:"Şimdi İletişime Geçin"
        },
        ru: {
          navHome:"Главная",navAbout:"О нас",navProducts:"Продукция",navAdvantages:"Преимущества",navPartner:"Партнеры",
          heroTitle:"Глобальное стратегическое партнерство",heroSubtitle:"ZH-ENG",heroDesc1:"Поставка лифтовых запчастей, строительных изделий и сборных домов",heroDesc2:"Прямо из Китая | Качество | Лучшая цена",heroBtn:"Стать партнером",
          aboutTitle:"О нас",aboutDesc:"Ведущая внешнеторговая платформа для лифтовых запчастей и строительства.",aboutDesc2:"10+ лет опыта, 100+ стран.",aboutDesc3:"Честность, качество и взаимовыгодное сотрудничество.",
          supplier:"Сертифицированные поставщики",country:"Страны обслуживания",sales:"Годовые продажи",client:"Клиенты",
          productTitle:"Наша продукция",productDesc:"Стабильное качество и конкурентная цена",
          p1:"Лифтовые запчасти",p1d:"Электрические и механические детали, стабильные поставки",
          p2:"Строительная продукция",p2d:"Материалы, оборудование, комплексное обслуживание",
          p3:"Сборные дома",p3d:"Модульные и контейнерные дома, безопасно и быстро",
          advTitle:"Наши преимущества",
          a1:"Прямая заводская цена",a1d:"Без посредников, лучшая цена",
          a2:"Строгий контроль качества",a2d:"100% проверка перед отгрузкой",
          a3:"Комплексные поставки",a3d:"Экономия времени и средств",
          a4:"Быстрая доставка",a4d:"Своевременная доставка по миру",
          partnerTitle:"Стать нашим партнером",partnerDesc:"Ищем местных партнеров по всему миру",
          offer:"Мы предлагаем",o1:"Лучшая цена и поддержка",o2:"Гарантия качества",o3:"Маркетинговая поддержка",o4:"Долгосрочное сотрудничество",
          youdo:"Ваша задача",y1:"Развивать местных клиентов",y2:"Создавать взаимовыгодное партнерство",y3:"Поддерживать рынок и бренд",
          contactBtn:"Связаться с нами"
        },
        fr: {
          navHome:"Accueil",navAbout:"À propos",navProducts:"Produits",navAdvantages:"Avantages",navPartner:"Partenaires",
          heroTitle:"Partenariat Stratégique Global",heroSubtitle:"ZH-ENG",heroDesc1:"Approvisionnement intégré pour ascenseurs, produits techniques et maisons préfabriquées",heroDesc2:"Direct de Chine | Qualité | Meilleur prix",heroBtn:"Devenir Partenaire",
          aboutTitle:"À propos de nous",aboutDesc:"Plateforme leader spécialisée dans les ascenseurs et la construction.",aboutDesc2:"10+ ans d'expérience, 100+ pays.",aboutDesc3:"Intégrité, qualité et partenariat gagnant-gagnant.",
          supplier:"Fournisseurs Certifiés",country:"Pays Desservis",sales:"Ventes Annuelles",client:"Clients",
          productTitle:"Nos Produits",productDesc:"Qualité stable et prix compétitif",
          p1:"Composants d'ascenseur",p1d:"Pièces électriques et mécaniques, approvisionnement stable",
          p2:"Produits de construction",p2d:"Matériaux, équipements, service intégré",
          p3:"Maisons préfabriquées",p3d:"Maisons modulaires et conteneurs, sûres et rapides",
          advTitle:"Nos Avantages",
          a1:"Prix usine direct",a1d:"Sans intermédiaire, meilleur prix garanti",
          a2:"Contrôle qualité strict",a2d:"100% inspection avant expédition",
          a3:"Approvisionnement complet",a3d:"Économie de temps et coût",
          a4:"Livraison rapide",a4d:"Livraison dans le monde entier",
          partnerTitle:"Devenir Partenaire Global",partnerDesc:"Nous recherchons des partenaires locaux dans le monde",
          offer:"Nous offrons",o1:"Meilleur prix et support",o2:"Garantie qualité",o3:"Support marketing",o4:"Coopération longue durée",
          youdo:"Votre rôle",y1:"Développer des clients locaux",y2:"Créer un partenariat gagnant-gagnant",y3:"Gérer le marché et la marque",
          contactBtn:"Nous contacter"
        },
        pt: {
          navHome:"Início",navAbout:"Sobre",navProducts:"Produtos",navAdvantages:"Vantagens",navPartner:"Parceiros",
          heroTitle:"Parceria Estratégica Global",heroSubtitle:"ZH-ENG",heroDesc1:"Fornecimento integrado para peças de elevador, produtos de engenharia e casas pré-fabricadas",heroDesc2:"Direto da China | Qualidade | Melhor preço",heroBtn:"Seja Parceiro",
          aboutTitle:"Sobre Nós",aboutDesc:"Plataforma líder em comércio exterior especializada em elevadores e construção.",aboutDesc2:"10+ anos de experiência, 100+ países.",aboutDesc3:"Integridade, qualidade e parceria vantajosa.",
          supplier:"Fornecedores Certificados",country:"Países Atendidos",sales:"Vendas Anuais",client:"Clientes",
          productTitle:"Nossos Produtos",productDesc:"Qualidade estável e preço competitivo",
          p1:"Componentes de Elevador",p1d:"Peças elétricas e mecânicas, fornecimento estável",
          p2:"Produtos de Engenharia",p2d:"Materiais, equipamentos, serviço integrado",
          p3:"Casas Pré-fabricadas",p3d:"Casas modulares e contêineres, seguras e rápidas",
          advTitle:"Nossas Vantagens",
          a1:"Preço de fábrica",a1d:"Sem intermediários, melhor preço garantido",
          a2:"Controle rigoroso",a2d:"100% inspeção antes do envio",
          a3:"Fornecimento completo",a3d:"Economia de tempo e custo",
          a4:"Entrega rápida",a4d:"Entrega em todo o mundo",
          partnerTitle:"Seja Nosso Parceiro",partnerDesc:"Buscamos parceiros locais no mundo todo",
          offer:"Oferecemos",o1:"Melhor preço e suporte",o2:"Garantia de qualidade",o3:"Suporte de marketing",o4:"Cooperação longa duração",
          youdo:"Sua função",y1:"Desenvolver clientes locais",y2:"Criar parceria vantajosa",y3:"Manter mercado e marca",
          contactBtn:"Contate-nos Agora"
        }
      }
    }
  },
  mounted() { this.changeLang() },
  methods: {
    changeLang() {
      this.t = this.messages[this.lang]
      document.documentElement.lang = this.lang
    }
  }
}
</script>

<style>
/* 完全隔离全局CSS */
.isolate-page,
.isolate-page * {
  all: unset !important;
  box-sizing: border-box !important;
}
.isolate-page {
  display: block !important;
  width: 100% !important;
  min-height: 100vh !important;
  background: #0a192f !important;
  color: #e6f1ff !important;
  font-family: 'Segoe UI', Roboto, sans-serif !important;
  scroll-behavior: smooth !important;
}

/* 导航 */
.isolate-page nav {
  position: fixed !important;
  top: 0 !important;
  width: 100% !important;
  background: rgba(10,25,47,0.95) !important;
  padding: 15px 5% !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  z-index: 999 !important;
  backdrop-filter: blur(10px) !important;
  border-bottom: 1px solid #233554 !important;
  flex-wrap: wrap !important;
  gap: 10px !important;
}
.isolate-page .logo {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #64ffda !important;
  white-space: nowrap !important;
}
.isolate-page .nav-group { display: flex !important; align-items: center !important; gap: 20px !important; }
.isolate-page .nav-links { display: flex !important; gap: 15px !important; }
.isolate-page .nav-links a {
  color: #ccd6f6 !important;
  text-decoration: none !important;
  font-size: 14px !important;
  transition: 0.3s !important;
}
.isolate-page .nav-links a:hover { color: #64ffda !important; }
.isolate-page .lang {
  padding: 6px 10px !important;
  background: #112240 !important;
  color: #fff !important;
  border: 1px solid #64ffda !important;
  border-radius: 4px !important;
  display: inline-block !important;
}

/* 区块 */
.isolate-page section {
  display: flex !important;
  flex-direction: column !important;
  min-height: 100vh !important;
  padding: 100px 5% 60px !important;
  border-bottom: 1px solid #233554 !important;
  animation: fadeIn 0.8s ease !important;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 文字 */
.isolate-page h1 { font-size: 34px !important; line-height: 1.3 !important; margin-bottom: 15px !important; color: #fff !important; }
.isolate-page h2 { font-size: 28px !important; margin-bottom: 25px !important; position: relative !important; display: inline-block !important; color: #ccd6f6 !important; }
.isolate-page h2::after { content: '' !important; width: 50px !important; height: 3px !important; background: #64ffda !important; position: absolute !important; left:0 !important; bottom:-8px !important; }
.isolate-page h3 { font-size: 20px !important; color: #64ffda !important; margin: 12px 0 !important; }
.isolate-page p { font-size: 16px !important; color: #8892b0 !important; line-height: 1.7 !important; margin-bottom: 12px !important; }
.isolate-page .highlight { color: #64ffda !important; }

/* 按钮 */
.isolate-page .btn {
  margin-top: 25px !important;
  padding: 12px 28px !important;
  background: transparent !important;
  border: 2px solid #64ffda !important;
  color: #64ffda !important;
  border-radius: 4px !important;
  text-decoration: none !important;
  display: inline-block !important;
  transition: 0.3s !important;
}
.isolate-page .btn:hover {
  background: rgba(100,255,218,0.1) !important;
  transform: translateY(-3px) !important;
}

/* 网格 */
.isolate-page .grid {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)) !important;
  gap: 20px !important;
  margin-top: 30px !important;
}
.isolate-page .card {
  background: #112240 !important;
  padding: 25px !important;
  border-radius: 8px !important;
  border: 1px solid #233554 !important;
  transition: 0.3s !important;
}
.isolate-page .card:hover {
  transform: translateY(-5px) !important;
  border-color: #64ffda !important;
}
.isolate-page .data {
  font-size: 36px !important;
  font-weight: bold !important;
  color: #64ffda !important;
  margin: 8px 0 !important;
}

/* 图文专用 */
.isolate-page .card-img img {
  width: 100% !important;
  height: 160px !important;
  object-fit: cover !important;
  border-radius: 6px !important;
  margin-bottom: 15px !important;
}
.isolate-page .card-icon {
  text-align: center !important;
  font-size: 36px !important;
}

/* 布局行 */
.isolate-page .hero-inner,
.isolate-page .about-row,
.isolate-page .partner-row {
  display: flex !important;
  align-items: center !important;
  gap: 40px !important;
  margin-top: 20px !important;
}
.isolate-page .hero-left,
.isolate-page .about-left,
.isolate-page .partner-left {
  flex: 1 !important;
}
.isolate-page .hero-right,
.isolate-page .about-right,
.isolate-page .partner-right {
  flex: 1 !important;
}
.isolate-page img {
  width: 100% !important;
  border-radius: 10px !important;
  box-shadow: 0 8px 20px rgba(0,0,0,0.3) !important;
}

/* 响应式 */
@media (max-width:900px) {
  .isolate-page .hero-inner,
  .isolate-page .about-row,
  .isolate-page .partner-row {
    flex-direction: column !important;
    text-align: center !important;
  }
}
@media (max-width:768px) {
  .isolate-page h1 { font-size: 26px !important; }
  .isolate-page h2 { font-size: 22px !important; }
  .isolate-page .nav-links a { font-size: 12px !important; }
}
</style>
